import { PORTAL_API_BASE_URL } from '../../../../constants';
import request from '../../../../util/APIUtils';

const SERVICES = `${PORTAL_API_BASE_URL}/api/admin/services`;
const SYSTEMS = `${PORTAL_API_BASE_URL}/api/admin/service-systems`;
const req = (opts) => request({ ...opts, throw400Error: true });

/** @returns {Promise<Array>} all service catalog entries */
export function listServices() {
  return req({ method: 'GET', url: SERVICES });
}

/** @returns {Promise<Object>} a single service catalog entry */
export function getService(serviceId) {
  return req({ method: 'GET', url: `${SERVICES}/${encodeURIComponent(serviceId)}` });
}

/** Create a new service (backend also provisions the Strapi CMS record). */
export function createService(body) {
  return req({ body: JSON.stringify(body), method: 'POST', url: SERVICES });
}

/** Modify an existing service (no CMS re-sync; service name is immutable). */
export function updateService(serviceId, body) {
  return req({ body: JSON.stringify(body), method: 'PUT', url: `${SERVICES}/${encodeURIComponent(serviceId)}` });
}

/** @returns {Promise<Array>} system (sys_ref) options for the system dropdown */
export function listSystems() {
  return req({ method: 'GET', url: SYSTEMS });
}

/** Mint a new system (sys_ref) row for the "add new system" inline flow. */
export function createSystem(body) {
  return req({ body: JSON.stringify(body), method: 'POST', url: SYSTEMS });
}
